var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goals-chart"},[_c('design-2021-apprentice-basic-bar-chart-component',{attrs:{"series":_vm.barChartData.series,"options":_vm.barChartData.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }